export const PERSONAL_DETAILS_OPTIONS = {
  YEARS_OLD: "Patient.YearsOld",
  DATE_OF_BIRTH: "Patient.DateOfBirth",
  SEX: "Patient.Sex",
  MARITAL_STATUS: "Patient.MaritalStatus",
  SSN_NUMBER: "Patient.SSNNumber",
};
